
const contactUs = {
  'contactUs.title': 'Need a Sponsor? Need Help?',
  'contactUs.subtitle': "We're here to help",
  'contactUs.whatsapp.title': 'Contact us via WhatsApp',
  'contactUs.email.title': 'Contact us via email',
  'contactUs.whatsapp.urgent': 'For urgent inquiries, contact us directly on WhatsApp. Our team will respond to you as soon as possible.',
  'contactUs.languages.english': 'English',
  'contactUs.languages.italian': 'Italiano',
  'contactUs.languages.spanish': 'Español',
  'contactUs.languages.german': 'Deutsch',
  'contactUs.languages.croatian': 'Hrvatski',
  'contactUs.languages.turkish': 'Türkçe',
  'contactUs.languages.french': 'Français',
  'contactUs.languages.arabic': 'العربية',
};

export default contactUs;
